import script from "./ScreenMirrorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScreenMirrorModal.vue?vue&type=script&setup=true&lang=ts"

import "./ScreenMirrorModal.vue?vue&type=style&index=0&id=ac35c9ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac35c9ea"]])

export default __exports__